module.exports = __webpack_public_path__ + "img/icon12.71fa5ca2.png";